"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpResult = void 0;
/**
 * A HttpResult represents the result returned from a REST api.
 */
class HttpResult {
    constructor() { }
    static fromOk(result) {
        if (result.hasValue)
            return result.value;
        else
            return undefined;
    }
    /**
     * Converts a "Bad" result to its HTTP representation.
     * @param result The result object.
     */
    static fromBad(result) {
        return result;
    }
}
exports.HttpResult = HttpResult;
//# sourceMappingURL=HttpResult.js.map